import PropTypes from 'prop-types';
import { FormGroup, FormHelpText } from '@spotify-internal/encore-web';

import TextField from 'components/Fields/TextField/TextField';
import {
  withFullTranslationKey,
  CLAIM_DETAILS,
} from 'components/ContentReporting/ContentLegalReporting/content-legal-reporting-config';
import CheckboxField from 'components/ContentReporting/Form/Fields/CheckboxField/CheckboxField';
import { getFieldValid, getFieldValue } from 'components/ContentReporting/form-utils';

const TerritoriesFields = ({
  t,
  formData,
  handleFieldChange,
  territoryList,
  isOtherTerritorySelected,
  forceValidation,
}) => {
  const handleCheckboxChange = (parentHandleChange, fieldValue) => element => {
    // the onChange is called also on the first render, see BaseField
    if (!element.target) {
      return;
    }
    const currentTerritories = fieldValue(CLAIM_DETAILS.fields.CLAIM_TERRITORIES);
    const newTerritories = {
      ...currentTerritories,
      [element.target.name]: element.target.checked,
    };
    parentHandleChange({
      fieldIdentifier: CLAIM_DETAILS.fields.CLAIM_TERRITORIES,
      value: newTerritories,
      valid: Object.values(newTerritories).some(x => !!x),
    });
  };

  const fieldValue = getFieldValue(formData);
  const fieldValid = getFieldValid(formData);
  return (
    <FormGroup key="territory-checkboxes" label={t('territories')} indicator="required">
      {territoryList.map(territory => (
        <CheckboxField
          key={territory}
          field={{ name: territory, type: 'checkbox', required: false }}
          label={t(withFullTranslationKey(territory))}
          onFieldChange={handleCheckboxChange(handleFieldChange, fieldValue)}
          value={
            !!fieldValue(CLAIM_DETAILS.fields.CLAIM_TERRITORIES) &&
            !!fieldValue(CLAIM_DETAILS.fields.CLAIM_TERRITORIES)[territory]
          }
        />
      ))}
      {!fieldValid(CLAIM_DETAILS.fields.CLAIM_TERRITORIES) && (
        <FormHelpText error>{t('territory_selection_required')}</FormHelpText>
      )}
      {isOtherTerritorySelected && (
        <TextField
          field={{
            name: CLAIM_DETAILS.fields.CLAIM_OTHER_TERRITORIES,
            type: 'text',
            required: true,
            maxlength: 244,
            labelOverride: t(CLAIM_DETAILS.labels.CLAIM_OTHER_TERRITORIES),
          }}
          value={fieldValue(CLAIM_DETAILS.fields.CLAIM_OTHER_TERRITORIES)}
          valid={fieldValid(CLAIM_DETAILS.fields.CLAIM_OTHER_TERRITORIES)}
          onFieldChange={handleFieldChange}
          forceValidation={forceValidation}
        />
      )}
    </FormGroup>
  );
};

TerritoriesFields.propTypes = {
  t: PropTypes.func.isRequired,
  formData: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
  territoryList: PropTypes.arrayOf(PropTypes.string),
  isOtherTerritorySelected: PropTypes.bool.isRequired,
  forceValidation: PropTypes.bool.isRequired,
};

export default TerritoriesFields;
